var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DateRangePicker as ReactDateRange, } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { Button, Dialog, DialogActions, TextField, styled, useTheme } from '@mui/material';
import { useState } from 'react';
import { endOfISOWeek, endOfMonth, endOfQuarter, endOfYear, startOfISOWeek, startOfMonth, startOfQuarter, startOfYear, subDays, } from 'date-fns';
var empty = [];
function createPerfStaticRange(label, minusDays) {
    return {
        range: function (props) {
            var date = new Date();
            return { startDate: subDays(date, minusDays), endDate: subDays(date, 1) };
        },
        isSelected: function (range) {
            var _a, _b;
            var date = new Date();
            return (((_a = range.startDate) === null || _a === void 0 ? void 0 : _a.toDateString()) === subDays(date, minusDays).toDateString() &&
                ((_b = range.endDate) === null || _b === void 0 ? void 0 : _b.toDateString()) === subDays(date, 1).toDateString());
        },
        label: label,
    };
}
export var perfStaticRanges = [
    createPerfStaticRange('Last 7 days', 7),
    createPerfStaticRange('Last 14 days', 14),
    createPerfStaticRange('Last 30 days', 30),
    createPerfStaticRange('Last 3 months', 90),
    createPerfStaticRange('Last 6 months', 180),
    createPerfStaticRange('Last 12 months', 365),
];
var ReactDateRangeContainer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        '& .rdrDefinedRangesWrapper': {
            background: 'transparent',
            borderRight: '1px solid rgba(0,0,0,0.1)',
            color: theme.palette.text.primary,
            fontFamily: theme.typography.fontFamily,
        },
        '& .rdrStaticRange': {
            background: 'rgba(0,0,0,0.06)',
            borderBottom: '1px solid rgba(0,0,0,0.1)',
            '&:hover .rdrStaticRangeLabel, .rdrStaticRange:focus .rdrStaticRangeLabel': {
                background: 'rgba(0,0,0,0.1)',
            },
            color: theme.palette.text.primary,
            fontFamily: theme.typography.fontFamily,
        },
        '& .rdrCalendarWrapper': {
            background: 'transparent',
            color: theme.palette.text.primary,
            fontFamily: theme.typography.fontFamily,
            '& .rdrMonthAndYearPickers select': {
                color: theme.palette.text.primary,
                fontFamily: theme.typography.fontFamily,
                '& option': {
                    color: '#3e484f',
                    fontFamily: theme.typography.fontFamily,
                },
            },
            '& .rdrDayNumber span': {
                color: theme.palette.text.primary,
            },
            '& .rdrDayPassive .rdrDayNumber span': {
                color: theme.palette.text.disabled,
            },
        },
        '& .rdrDateDisplayWrapper': {
            background: 'transparent',
            '& .rdrDateDisplayItem': {
                background: 'rgba(0,0,0,0.06)',
                '& input': {
                    color: theme.palette.text.primary,
                    fontFamily: theme.typography.fontFamily,
                },
            },
        },
    });
});
function v(config, defaults) {
    return config !== undefined ? config : defaults;
}
export function transformDates(startDate, endDate, granularity) {
    switch (granularity) {
        case 'week':
            return { startDate: startDate && startOfISOWeek(startDate), endDate: endDate && endOfISOWeek(endDate) };
        case 'month':
            return { startDate: startDate && startOfMonth(startDate), endDate: endDate && endOfMonth(endDate) };
        case 'quarter':
            return { startDate: startDate && startOfQuarter(startDate), endDate: endDate && endOfQuarter(endDate) };
        case 'year':
            return { startDate: startDate && startOfYear(startDate), endDate: endDate && endOfYear(endDate) };
        default:
            return { startDate: startDate, endDate: endDate };
    }
}
function InnerPicker(props) {
    var _a, _b, _c, _d, _e, _f;
    var theme = useTheme();
    var _g = useState({
        startDate: props.defaultValue ? props.defaultValue[0] : undefined,
        endDate: props.defaultValue ? props.defaultValue[1] : undefined,
        key: 'selection',
    }), value = _g[0], setValue = _g[1];
    return (_jsxs(_Fragment, { children: [_jsx(ReactDateRangeContainer, { children: _jsx(ReactDateRange, __assign({}, props.DateRangePickerProps, { ranges: [value], onChange: function (dict) {
                        setValue(__assign(__assign({}, transformDates(dict.selection.startDate, dict.selection.endDate, props.granularity)), { key: 'selection' }));
                    }, staticRanges: props.staticRanges, rangeColors: [props.color || theme.palette.primary.main], editableDateInputs: v((_a = props.DateRangePickerProps) === null || _a === void 0 ? void 0 : _a.editableDateInputs, true), moveRangeOnFirstSelection: v((_b = props.DateRangePickerProps) === null || _b === void 0 ? void 0 : _b.moveRangeOnFirstSelection, false), showPreview: v((_c = props.DateRangePickerProps) === null || _c === void 0 ? void 0 : _c.showPreview, false), weekStartsOn: v((_d = props.DateRangePickerProps) === null || _d === void 0 ? void 0 : _d.weekStartsOn, 1), inputRanges: v((_e = props.DateRangePickerProps) === null || _e === void 0 ? void 0 : _e.inputRanges, empty), retainEndDateOnFirstSelection: v((_f = props.DateRangePickerProps) === null || _f === void 0 ? void 0 : _f.retainEndDateOnFirstSelection, props.retainEndDateOnFirstSelection) }), void 0) }, void 0), _jsxs(DialogActions, { children: [props.clearable && _jsx(Button, __assign({ onClick: function () { return props.onSubmit(null); } }, { children: props.clearText || 'Clear' }), void 0), _jsx(Button, __assign({ onClick: function () { return props.onSubmit(value.startDate && value.endDate ? [value.startDate, value.endDate] : null); } }, { children: props.saveText || 'Save' }), void 0)] }, void 0)] }, void 0));
}
function toDateArray(dates) {
    if (typeof dates[0] === 'string') {
        return [new Date(dates[0]), new Date(dates[1])];
    }
    else {
        return dates;
    }
}
var defaultRenderInput = function (props, value) { return (_jsx(TextField, __assign({}, props, { value: value ? value.map(function (date) { return date.toLocaleDateString(); }).join(' to ') : '' }), void 0)); };
export function DateRangePicker(props) {
    var value = props.value, onChange = props.onChange, renderInput = props.renderInput, saveText = props.saveText, clearable = props.clearable, clearText = props.clearText, staticRanges = props.staticRanges, placeholder = props.placeholder, color = props.color, retainEndDateOnFirstSelection = props.retainEndDateOnFirstSelection, granularity = props.granularity;
    var _a = useState(false), open = _a[0], setOpen = _a[1];
    return (_jsxs(_Fragment, { children: [(renderInput || defaultRenderInput)({ placeholder: placeholder, onClick: function () { return setOpen(true); } }, value ? toDateArray(value) : null), _jsx(Dialog, __assign({ open: open, onClose: function () { return setOpen(false); } }, { children: _jsx(InnerPicker, { defaultValue: value && toDateArray(value), onSubmit: function (value) {
                        onChange(value);
                        setOpen(false);
                    }, saveText: saveText, clearable: clearable, clearText: clearText, staticRanges: staticRanges, color: color, retainEndDateOnFirstSelection: retainEndDateOnFirstSelection, DateRangePickerProps: props.DateRangePickerProps, granularity: granularity }, void 0) }), void 0)] }, void 0));
}
